import React from "react";
import { Card, Button } from "antd";

const Reseller = () => {
  return (
    <div style={{ width: "93%", maxWidth: 1200, margin: "15px auto" }}>
      <Card style={{ marginBottom: "20px" }}>
        <h2 style={{ fontSize: "24px", marginBottom: "15px" }}>
          Become Our Reseller
        </h2>
        <p
          style={{ fontSize: "16px", lineHeight: "1.6", marginBottom: "15px" }}
        >
          Join our reseller program to get wholesale prices and exclusive
          support. We offer the industry's highest quality fake ID products,
          helping your business thrive.
        </p>
        <h3
          style={{ fontSize: "18px", marginTop: "20px", marginBottom: "10px" }}
        >
          Reseller Benefits:
        </h3>
        <ul
          style={{
            listStyleType: "disc",
            paddingLeft: "20px",
            marginBottom: "20px",
          }}
        >
          <li>Wholesale Price - Enjoy up to more 10% discount off</li>
          <li>Priority Customer Support - 24/7 dedicated service</li>
          <li>Bulk Order Processing - Efficient and quick</li>
          <li>Professional Training - Product knowledge and sales skills</li>
          <li>Marketing Support - Provide marketing materials</li>
        </ul>
        <Button
          type="primary"
          style={{
            fontSize: "16px",
          }}
          onClick={() =>
            (window.location.href = "mailto:service@getyourfakeid.com")
          }
        >
          Apply Now
        </Button>
      </Card>
    </div>
  );
};

export default Reseller;
